export default __webpack_public_path__ + "static/media/gia-table_over-md.bff6907c.png";